<template>
  <RegisterPartner :internal="true"></RegisterPartner>
  </template>
  
  <script>
  export default {
    name: 'PartnerNew',
  }
  </script>
  